import { useAccommodationHotelPolicyI18nFormModelContext } from "../../../../context";

export const useUpdateButton = () => {
	const { viewModel, onUpdate } = useAccommodationHotelPolicyI18nFormModelContext();

	const isValid = !viewModel.hasError && viewModel.isDirty;

	return {
		isValid,
		onUpdate,
	};
};
